import axios from "axios";
import { toast } from "react-toastify";
import {
  isPreliminaryAnswerFailResponse,
  shouldTreatPreliminarySubmitAsFail,
  getPreliminaryFailMessage,
} from "../../helper/preliminarySurvey";

const getApiErrorMessage = (error) =>
  error?.response?.data?.message || error?.message || "Something went wrong";

export const START_SURVEY_REQUEST = "START_SURVEY_REQUEST";
export const START_SURVEY_SUCCESS = "START_SURVEY_SUCCESS";
export const START_SURVEY_FAILURE = "START_SURVEY_FAILURE";
export const START_SURVEY_RESET = "START_SURVEY_RESET";
export const IS_LAST_QUESTION_REQUEST =
  "IS_LAST_QUESTION_REQUEST";
export const IS_LAST_QUESTION_SUCCESS =
  "IS_LAST_QUESTION_SUCCESS";
export const IS_LAST_QUESTION_FAILURE =
  "IS_LAST_QUESTION_FAILURE";

export const GET_SURVEY_QUESTIONS_REQUEST = "GET_SURVEY_QUESTIONS_REQUEST";
export const GET_SURVEY_QUESTIONS_SUCCESS = "GET_SURVEY_QUESTIONS_SUCCESS";
export const GET_SURVEY_QUESTIONS_FAILURE = "GET_SURVEY_QUESTIONS_FAILURE";
export const GET_SURVEY_QUESTIONS_RESET = "GET_SURVEY_QUESTIONS_RESET";

export const SUBMIT_SURVEY_ANSWER_REQUEST = "SUBMIT_SURVEY_ANSWER_REQUEST";
export const SUBMIT_SURVEY_ANSWER_SUCCESS = "SUBMIT_SURVEY_ANSWER_SUCCESS";
export const SUBMIT_SURVEY_ANSWER_FAILURE = "SUBMIT_SURVEY_ANSWER_FAILURE";

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const UPDATE_USER_PROFILE_REQUEST = "UPDATE_USER_PROFILE_REQUEST";
export const UPDATE_USER_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS";
export const UPDATE_USER_PROFILE_FAILURE = "UPDATE_USER_PROFILE_FAILURE";

export const IS_USER_PARTICIPATED_IN_SURVEY_REQUEST = "IS_USER_PARTICIPATED_IN_SURVEY_REQUEST";
export const IS_USER_PARTICIPATED_IN_SURVEY_SUCCESS = "IS_USER_PARTICIPATED_IN_SURVEY_SUCCESS";
export const IS_USER_PARTICIPATED_IN_SURVEY_FAILURE = "IS_USER_PARTICIPATED_IN_SURVEY_FAILURE";
export const IS_USER_PARTICIPATED_IN_SURVEY_RESET = "IS_USER_PARTICIPATED_IN_SURVEY_RESET";

export const GET_PRELIMINARY_SURVEY_REQUEST = "GET_PRELIMINARY_SURVEY_REQUEST";
export const GET_PRELIMINARY_SURVEY_SUCCESS = "GET_PRELIMINARY_SURVEY_SUCCESS";
export const GET_PRELIMINARY_SURVEY_FAILURE = "GET_PRELIMINARY_SURVEY_FAILURE";

export const SUBMIT_PRELIMINARY_SURVEY_ANSWER_REQUEST = "SUBMIT_PRELIMINARY_SURVEY_ANSWER_REQUEST";
export const SUBMIT_PRELIMINARY_SURVEY_ANSWER_SUCCESS = "SUBMIT_PRELIMINARY_SURVEY_ANSWER_SUCCESS";
export const SUBMIT_PRELIMINARY_SURVEY_ANSWER_FAILURE = "SUBMIT_PRELIMINARY_SURVEY_ANSWER_FAILURE";

export const SUBMIT_CARACTERISTICS_SURVEY_ANSWER_REQUEST = "SUBMIT_CARACTERISTICS_SURVEY_ANSWER_REQUEST";
export const SUBMIT_CARACTERISTICS_SURVEY_ANSWER_SUCCESS = "SUBMIT_CARACTERISTICS_SURVEY_ANSWER_SUCCESS";
export const SUBMIT_CARACTERISTICS_SURVEY_ANSWER_FAILURE = "SUBMIT_CARACTERISTICS_SURVEY_ANSWER_FAILURE";

export const GET_PRELIMINARY_SURVEY_RESULTS_REQUEST = "GET_PRELIMINARY_SURVEY_RESULTS_REQUEST";
export const GET_PRELIMINARY_SURVEY_RESULTS_SUCCESS = "GET_PRELIMINARY_SURVEY_RESULTS_SUCCESS";
export const GET_PRELIMINARY_SURVEY_RESULTS_FAILURE = "GET_PRELIMINARY_SURVEY_RESULTS_FAILURE";

export const RESET_PASSWORD_USING_PHONE_REQUEST = "RESET_PASSWORD_USING_PHONE_REQUEST";
export const RESET_PASSWORD_USING_PHONE_SUCCESS = "RESET_PASSWORD_USING_PHONE_SUCCESS";
export const RESET_PASSWORD_USING_PHONE_FAILURE = "RESET_PASSWORD_USING_PHONE_FAILURE";

export const GET_USER_SURVEY_ANSWER_REQUEST = "GET_USER_SURVEY_ANSWER_REQUEST";
export const GET_USER_SURVEY_ANSWER_SUCCESS = "GET_USER_SURVEY_ANSWER_SUCCESS";
export const GET_USER_SURVEY_ANSWER_FAILURE = "GET_USER_SURVEY_ANSWER_FAILURE";

export const GET_SAME_SURVEY_ANSWER_REQUEST = "GET_SAME_SURVEY_ANSWER_REQUEST";
export const GET_SAME_SURVEY_ANSWER_SUCCESS = "GET_SAME_SURVEY_ANSWER_SUCCESS";
export const GET_SAME_SURVEY_ANSWER_FAILURE = "GET_SAME_SURVEY_ANSWER_FAILURE";



export const startSurveyAction = (survey, privacy) => {
  return async (dispatch) => {
    dispatch({ type: START_SURVEY_REQUEST });
    const token = localStorage.getItem("Authorization");
    const language = localStorage.getItem("language");
    try {
      // Normalize privacy to API enum: \"Anonymous\" | \"Private\" | \"Public\"
      const normalizePrivacy = (val) => {
        const v = (val || '').toString().trim().toLowerCase();
        if (v === 'anonymous' || v === 'anon' || v === 'anonimo' || v === 'annonums') return 'Anonymous';
        if (v === 'private' || v === 'privato') return 'Private';
        if (v === 'public' || v === 'pubblico') return 'Public';
        return 'Private';
      };
      const payload = { survey, surveyPrivacy: normalizePrivacy(privacy) };
      // Debug: verify payload shape for start survey
      // eslint-disable-next-line no-console
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/start/servey/v1`,
        payload,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      dispatch({ type: START_SURVEY_SUCCESS, payload: response.data });
      const successMessage = language === "Italian" ? "Sondaggio avviato con successo" : "Survey started successfully";
      toast.success(successMessage);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("[startSurveyAction] Error:", {
        status: error?.response?.status,
        message: error?.response?.data?.message,
      });
      dispatch({
        type: START_SURVEY_FAILURE,
        payload: error.response.data.message,
      });
      toast.error(error.response.data.message);
    }
  };
};

export const isLastQuestionAction = (survey) => {
  return async (dispatch) => {
    dispatch({ type: IS_LAST_QUESTION_REQUEST });
    const token = localStorage.getItem("Authorization");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/survey/last/question/v1`,
        { survey },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      dispatch({
        type: IS_LAST_QUESTION_SUCCESS,
        payload: response?.data,
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: IS_LAST_QUESTION_FAILURE,
        payload: getApiErrorMessage(error),
      });
      return { success: false };
    }
  };
};

export const getAttemptSurveyQuestionsListAction = (id) => {
  return async (dispatch) => {
    dispatch({ type: GET_SURVEY_QUESTIONS_REQUEST });
    const token = localStorage.getItem("Authorization");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/user/survey/details/${id}/v1`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      dispatch({ type: GET_SURVEY_QUESTIONS_SUCCESS, payload: response?.data });
    } catch (error) {
      dispatch({
        type: GET_SURVEY_QUESTIONS_FAILURE,
        payload: error.response.data.message,
      });
    }
  };
};


export const submitSurveyAnswerAction = (survey, question, answer, comment, skipped) => {
  return async (dispatch) => {
    dispatch({ type: SUBMIT_SURVEY_ANSWER_REQUEST });
    const token = localStorage.getItem("Authorization");
    const language = localStorage.getItem("language");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/survey/answer/v2`,
        {
          survey,
          question,
          answer,
          comment,
          skipped
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      dispatch({
        type: SUBMIT_SURVEY_ANSWER_SUCCESS,
        payload: response?.data,
      });
      return { success: true };
    } catch (error) {
      const message = getApiErrorMessage(error);
      dispatch({
        type: SUBMIT_SURVEY_ANSWER_FAILURE,
        payload: message,
      });
      toast.error(message || (language === "Italian" ? "Invio della risposta fallito" : "Failed to save answer"));
      return { success: false };
    }
  };
};

export const resetPasswordAction = (data) => {
  return async (dispatch) => {
    dispatch({ type: RESET_PASSWORD_REQUEST });
    const token = localStorage.getItem("Authorization");
    const language = localStorage.getItem("language");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/forgot/password/v1`,
        data
      );
      dispatch({
        type: RESET_PASSWORD_SUCCESS,
        payload: response?.data,
      });
      toast.success(language === "Italian" ? "Email inviata con successo!" : "Email sent successfully!");
    } catch (error) {
      dispatch({
        type: RESET_PASSWORD_FAILURE,
        payload: error.response.data.message,
      });
      toast.error(error?.response?.data?.message);
    }
  };
};


export const updateUserProfileAction = (data) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_USER_PROFILE_REQUEST });
    const token = localStorage.getItem("Authorization");
    const language = localStorage.getItem("language");
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/update/user/details/v1`,
        data,
        {
          headers: {
            Authorization: token,
          },
        }
      )
      dispatch({
        type: UPDATE_USER_PROFILE_SUCCESS,
        payload: response?.data,
      });
      const successMessage = language === "Italian" ? "Profilo aggiornato con successo" : "Profile updated successfully";
      toast.success(successMessage);
    } catch (error) {
      dispatch({
        type: UPDATE_USER_PROFILE_FAILURE,
        payload: error.response.data.message,
      });
      toast.error(error?.response?.data?.message);
    }
  };
};


export const isUserParticipatedInSurveyAction = () => {
  return async (dispatch) => {
    dispatch({ type: IS_USER_PARTICIPATED_IN_SURVEY_REQUEST });
    const token = localStorage.getItem("Authorization");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/user/surveys/participate/v1`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      dispatch({ type: IS_USER_PARTICIPATED_IN_SURVEY_SUCCESS, payload: response?.data });
    } catch (error) {
      dispatch({ type: IS_USER_PARTICIPATED_IN_SURVEY_FAILURE, payload: error.response.data.message });
    }
  };
};


export const submitPreliminarySurveyAnswerAction = (surveyId, preliminaryQuestionId, answer) => {
  return async (dispatch) => {
    dispatch({ type: SUBMIT_PRELIMINARY_SURVEY_ANSWER_REQUEST });
    const token = localStorage.getItem("Authorization");
    // Normalize answer to _id string(s)
    const normalizedAnswer = Array.isArray(answer)
      ? answer.map((a) => (a && typeof a === 'object' && a._id ? a._id.toString() : a)).filter(Boolean)
      : (answer && typeof answer === 'object' && answer._id ? answer._id.toString() : answer);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/answer/preliminary/questions/v2`,
        { surveyId, preliminaryQuestionId, answer: normalizedAnswer },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      dispatch({ type: SUBMIT_PRELIMINARY_SURVEY_ANSWER_SUCCESS, payload: response?.data });

      if (isPreliminaryAnswerFailResponse(response?.data)) {
        const message = getPreliminaryFailMessage({ data: response?.data });
        return { success: false, failed: true, data: response?.data, message };
      }

      return { success: true, data: response?.data };
    } catch (error) {
      const message = getApiErrorMessage(error);
      dispatch({ type: SUBMIT_PRELIMINARY_SURVEY_ANSWER_FAILURE, payload: message });

      if (shouldTreatPreliminarySubmitAsFail(null, error)) {
        const failMessage = getPreliminaryFailMessage(null, error);
        return { success: false, failed: true, message: failMessage || message };
      }

      toast.error(message);
      return { success: false, failed: false, message };
    }
  }
}

// Now it is not used
export const getPreliminarySurveyAction = (survey, preliminary) => {
  return async (dispatch) => {
    dispatch({ type: GET_PRELIMINARY_SURVEY_REQUEST });
    const token = localStorage.getItem("Authorization");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/user/get/survey/preliminary/answer/${survey}/${preliminary}/v1`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      dispatch({ type: GET_PRELIMINARY_SURVEY_SUCCESS, payload: response?.data });
    } catch (error) {
      dispatch({ type: GET_PRELIMINARY_SURVEY_FAILURE, payload: error.response.data.message });
    }
  };
};


export const submitCaracteristicsSurveyAnswerAction = (surveyId, carachteristicsQuestionId, answer) => {
  return async (dispatch) => {
    dispatch({ type: SUBMIT_CARACTERISTICS_SURVEY_ANSWER_REQUEST });
    const token = localStorage.getItem("Authorization");
    // Normalize answer to _id string(s)
    const normalizedAnswer = Array.isArray(answer)
      ? answer.map((a) => (a && typeof a === 'object' && a._id ? a._id.toString() : a)).filter(Boolean)
      : (answer && typeof answer === 'object' && answer._id ? answer._id.toString() : answer);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/answer/carachteristics/v2`,
        { surveyId, carachteristicsQuestionId, answer: normalizedAnswer },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      dispatch({ type: SUBMIT_CARACTERISTICS_SURVEY_ANSWER_SUCCESS, payload: response?.data });
      return { success: true };
    } catch (error) {
      const message = getApiErrorMessage(error);
      dispatch({ type: SUBMIT_CARACTERISTICS_SURVEY_ANSWER_FAILURE, payload: message });
      toast.error(message);
      return { success: false };
    }
  }
}

export const getPreliminarySurveyResultsAction = (survey, preliminary) => {
  return async (dispatch) => {
    dispatch({ type: GET_PRELIMINARY_SURVEY_RESULTS_REQUEST });
    const token = localStorage.getItem("Authorization");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/user/get/survey/preliminary/answer/${survey}/${preliminary}/v1`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      dispatch({ type: GET_PRELIMINARY_SURVEY_RESULTS_SUCCESS, payload: response?.data });
    } catch (error) {
      dispatch({ type: GET_PRELIMINARY_SURVEY_RESULTS_FAILURE, payload: error.response.data.message });
    }
  }
}


export const resetPasswordUsingPhoneAction = (phone) => {
  return async (dispatch) => {
    dispatch({ type: RESET_PASSWORD_USING_PHONE_REQUEST });
    const token = localStorage.getItem("Authorization");
    const language = localStorage.getItem("language");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/resetpassword/phone/otp/v1`,
        { phone: phone.phone, password: phone.password },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      dispatch({ type: RESET_PASSWORD_USING_PHONE_SUCCESS, payload: response?.data });
      toast.success(language === "Italian" ? "Password resettata con successo" : "Password reset successfully");
    } catch (error) {
      dispatch({ type: RESET_PASSWORD_USING_PHONE_FAILURE, payload: error.response.data.message });
      toast.error(error?.response?.data?.message);
    }
  }
}


export const getUserSurveyAnswerAction = (survey, question) => {
  return async (dispatch) => {
    dispatch({ type: GET_USER_SURVEY_ANSWER_REQUEST });
    const token = localStorage.getItem("Authorization");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/user/get/survey/question/answer/${survey}/${question}/v1`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      dispatch({ type: GET_USER_SURVEY_ANSWER_SUCCESS, payload: response?.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: GET_USER_SURVEY_ANSWER_FAILURE, payload: error.response?.data?.message });
      return null;
    }
  }
}

export const getSameSurveyAnswerAction = (survey, question) => {
  return async (dispatch) => {
    dispatch({ type: GET_SAME_SURVEY_ANSWER_REQUEST });
    const token = localStorage.getItem("Authorization");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/user/survey/details/same/answers/${survey}/${question}/v1`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      dispatch({ type: GET_SAME_SURVEY_ANSWER_SUCCESS, payload: response?.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: GET_SAME_SURVEY_ANSWER_FAILURE, payload: error.response?.data?.message });
      return null;
    }
  }
}
